import { render, staticRenderFns } from "./CsimSchemaAttributeFormItem.vue?vue&type=template&id=0945102f"
import script from "./CsimSchemaAttributeFormItem.vue?vue&type=script&lang=js"
export * from "./CsimSchemaAttributeFormItem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports